import React, { useCallback, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { KeyValueSelect } from '../../shipment-configuration-widget/key-value-select';
import PropTypes from 'prop-types';
import { useAvailableInsuranceOptions } from '../../../services/insurance-service';
import { InsuranceProviders } from '../../../enums/insurance-providers';
import { insuranceProviderId } from '../constants';

const messages = defineMessages({
  sumOfAllProducts: {
    description: 'presets.insurance.sumOfAllProducts',
    defaultMessage: 'Sum of All Products',
    id: 'sNFzUN',
  },
  label: {
    description: 'presets.insurance.label',
    defaultMessage: 'Insurance',
    id: '83o17Y',
  },
});

export const InsuranceServicePresetOption = ({ data, onChange }) => {
  const intl = useIntl();
  const onInsuranceChange = useCallback(
    (value) => {
      onChange({ name: insuranceProviderId, value });
    },
    [onChange],
  );

  const sumOfProductsTranslation = intl.formatMessage(messages.sumOfAllProducts);
  const insuranceOptions = useAvailableInsuranceOptions();
  const filteredInsuranceOptions = useMemo(
    () =>
      insuranceOptions.map(({ insuranceOptionId, messageDescriptor, name }) => {
        const translation = intl.formatMessage(messageDescriptor);
        let key = translation;
        if (name !== InsuranceProviders.None.name) {
          key += ` (${sumOfProductsTranslation})`;
        }
        return { key, value: `${insuranceOptionId}` };
      }),
    [intl, sumOfProductsTranslation, insuranceOptions],
  );

  return (
    <KeyValueSelect
      items={filteredInsuranceOptions}
      label={intl.formatMessage(messages.label)}
      onChange={onInsuranceChange}
      selectedItem={data}
    />
  );
};

InsuranceServicePresetOption.propTypes = {
  data: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
